import jwtService from "services/jwtService";

export const CAPTCHA_FETCH_START = "CAPTCHA_FETCH_START";
export const CAPTCHA_FETCH_SUCCESS = "CAPTCHA_FETCH_SUCCESS";
export const CAPTCHA_FETCH_FAILURE = "CAPTCHA_FETCH_FAILURE";

export function sendCaptcha(page) {
  return (dispatch) => {
    dispatch({
      type: CAPTCHA_FETCH_START,
    });
    jwtService
      .getCaptch(page)
      .then((image) => {
        return dispatch({
          type: CAPTCHA_FETCH_SUCCESS,
          payload: image,
        });
      })
      .catch((error) => {
        return dispatch({
          type: CAPTCHA_FETCH_FAILURE,
          payload: error,
        });
      });
  };
}
